<div class="terms-of-service">
    <app-message-box [content]="errors"></app-message-box>

    @if (loading) {
        <app-wait></app-wait>
    } @else {
        <div class="terms-of-service-legal" [innerHtml]="terms | trustHtml"></div>

        <div class="button-row">
            <button type="button" class="btn btn-primary" (click)="closeDialog('terms-of-service')">Ok, Got It</button>
        </div>
    }
</div>
